import React, { useContext } from 'react';
import { keyBy } from 'utils/arrayUtils';
import { useQuery } from '@apollo/client';
import { useDispatch, useSelector } from 'react-redux';
import { portalConfigurationsActions } from 'redux/portalConfigurationReducer';
import { PortalConfigurationType, VendorProfile } from '@trnsact/trnsact-shared-types';

import { PortalConfigurationRenderProps } from '../types';
import { portalConfigurationApi, usePortalConfiguration } from '../api';
import { PortalConfigurationsResponse, PortalConfigurationsVariables } from '../api/types';
import { getPortalConfigurationDefaultConfig } from '../lib/getPortalConfigurationDefaultConfig';
import { CommonDataContext } from 'contexts/CommonDataContext';

interface Props {
  portalConfigTypes: PortalConfigurationType[];
  children: (options: PortalConfigurationRenderProps) => React.ReactNode;
}

export const PortalConfigContainer = ({ portalConfigTypes, children }: Props) => {
  const dispatch = useDispatch();

  const { isSuperAdminOrSingleAccount } = useContext(CommonDataContext);

  const vendorProfile = useSelector<any, VendorProfile>(state => state.vp);

  const { isPortalConfigurationSaving, handleSaveConfiguration } = usePortalConfiguration();

  useQuery<PortalConfigurationsResponse, PortalConfigurationsVariables>(portalConfigurationApi.fetchConfig, {
    skip: !vendorProfile,
    fetchPolicy: 'no-cache',
    variables: { vendorProfileId: vendorProfile.id, types: portalConfigTypes },
    onCompleted(response) {
      const savedConfigsByType = keyBy(response?.portalConfigurations ?? [], 'type') ?? {};
      const configsToSet = portalConfigTypes.map(
        type => savedConfigsByType[type] ?? getPortalConfigurationDefaultConfig(vendorProfile.id, type)
      );

      dispatch(portalConfigurationsActions.setConfigData(configsToSet));
    },
  });

  return (
    <>
      {children({
        isSuperAdminOrSingleAccount,
        vendorProfile,
        loading: isPortalConfigurationSaving,
        onSaveConfiguration: handleSaveConfiguration,
      })}
    </>
  );
};
